import { useState, Fragment,createContext, useContext  } from 'react';

const PredContext = createContext();

const PredProvider = ({ children }) => {

const [teamData, setTeamData] = useState([]);
const [id, setId] = useState();



  return (
    <PredContext.Provider value={{teamData, setTeamData, id, setId}}>
      {children}
    </PredContext.Provider>
  );
  }
  export {PredContext,PredProvider}